<template>
  <div class="active-list-tag-container">
    <img
      :src="statusImages[tags]"
      :alt="statusTexts[tags]"
      class="status-image"
    />
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import yugao from "@/assets/yugao.png"; // 0-未开始（预告）
import baoming from "@/assets/baoming.png"; // 1-报名中
import yubei from "@/assets/yubei.png"; // 2-报名结束（预备中）
import ing from "@/assets/ing.png"; // 3-活动进行中
import over from "@/assets/over.png"; // 4-活动结束

defineProps({
  tags: {
    type: Number,
    required: true,
    validator: (value) => {
      return [0, 1, 2, 3, 4].includes(value);
    },
  },
});

// 状态文本对应表（用于alt属性）
const statusTexts = [
  "活动预告", // 0
  "活动报名", // 1
  "活动预备", // 2
  "进行中", // 3
  "已结束", // 4
];

// 状态图片对应表（根据tags值匹配对应图片）
const statusImages = [
  yugao, // 0
  baoming, // 1
  yubei, // 2
  ing, // 3
  over, // 4
];
</script>

<style lang="less" scoped>
@import "~@/styles/mixin.less";

.active-list-tag-container {
  .self-flex(flex-start);

  .status-image {
    width: auto;
    height: 16px;
  }
}
</style>
